import React from "react";
import { Button } from "components/ui/button";
import { MessageSquare, Clock } from "lucide-react";

interface DefaultQuestionsStepProps {
  onNext: (data: any) => void;
  initialData?: any;
  practiceData?: any;
}

export default function DefaultQuestionsStep({
  onNext,
}: DefaultQuestionsStepProps) {
  const handleSubmit = () => {
    // Pass empty data for now since this is coming soon
    onNext({
      defaultQueries: [],
      customPrompt: "",
      autoSubmitEnabled: false,
    });
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-orange-50 rounded-xl">
            <MessageSquare className="h-8 w-8 text-orange-600" />
          </div>
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Default Call Scripts
        </h2>
        <p className="text-lg text-gray-600">
          Customize your AI call scripts to streamline your workflow
        </p>
      </div>

      {/* Coming Soon Content */}
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-gray-50 rounded-2xl">
              <Clock className="h-12 w-12 text-gray-400" />
            </div>
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">
            Coming Soon
          </h3>
          <p className="text-gray-600 max-w-md mx-auto">
            We're working on advanced customization options for your AI call
            scripts. This feature will be available in a future update.
          </p>
        </div>
      </div>

      <div className="flex justify-end mt-8">
        <Button
          onClick={handleSubmit}
          className="bg-[#005151] hover:bg-[#004040] text-white px-8"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
